import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.auth.FirstTimeSetupPages.AcceptInvitationsStep', {
    title: 'You were invited to the following ApprovalMax organisations:',
    description:
        'After accepting invitation you’ll have access to these organisations. Your profile data will be visible to Account Owner and Administrators.',
    invitedBy: 'Invitation from {name}',
});
